import React from 'react';
import './SiteHeader.css';
import IllyaPhoto from '../Assets/illya.jpeg';

const navigationItems = [
    // Portfolio is hidden for now. Re-enable this entry (and the /portfolio route
    // in src/App.js) to bring the page back.
    // { label: 'Portfolio', href: '/portfolio', key: 'portfolio' },
    { label: 'Resume', href: '/resume', key: 'resume' },
    { label: 'X', href: 'https://x.com/ibakurov', external: true },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ibakurov', external: true },
    { label: 'GitHub', href: 'https://github.com/ibakurov', external: true },
    { label: 'Email', href: 'mailto:bakurov.illya@gmail.com' },
];

const SiteHeader = ({ currentPage }) => (
    <header className="site-header">
        <a className="site-header-wordmark" href="/">
            <img className="site-header-avatar" src={IllyaPhoto} alt="" />
            <span>Illya Bakurov</span>
        </a>
        <nav className="site-header-nav" aria-label="Primary navigation">
            {navigationItems.map(({ label, href, key, external }) => (
                <a
                    key={label}
                    href={href}
                    aria-current={key && key === currentPage ? 'page' : undefined}
                    target={external ? '_blank' : undefined}
                    rel={external ? 'noopener noreferrer' : undefined}
                >
                    {label}
                </a>
            ))}
        </nav>
    </header>
);

export default SiteHeader;
